import { useCallback } from 'react';
import { type OpenApiSchemaPriceIndexMarketplace } from '#shared/api/schema';
import { useIntegrationOzonSetup, useIntegrationWildberriesSetup, useIntegrationYandexMarketSetup } from '../api';
import { isIntegrationSourceConnected } from '../lib/isIntegrationSourceConnected';

export type IntegrationMarketplaceDatasourceConnectionState = 'loading' | 'connected' | 'disconnected';

export const useIntegrationMarketplaceDatasourceConnection = () => {
    const { data: wildberriesData, isSuccess: isWildberriesLoaded } = useIntegrationWildberriesSetup();
    const { data: ozonData, isSuccess: isOzonLoaded } = useIntegrationOzonSetup();
    const { data: yandexMarketData, isSuccess: isYandexMarketLoaded } = useIntegrationYandexMarketSetup();

    const getConnectionState = useCallback(
        (marketplace: OpenApiSchemaPriceIndexMarketplace): IntegrationMarketplaceDatasourceConnectionState => {
            switch (marketplace) {
                case 'wildberries':
                    if (!isWildberriesLoaded) {
                        return 'loading';
                    }

                    return isIntegrationSourceConnected.wildberries(wildberriesData) ? 'connected' : 'disconnected';
                case 'ozon':
                    if (!isOzonLoaded) {
                        return 'loading';
                    }

                    return isIntegrationSourceConnected.ozon(ozonData) ? 'connected' : 'disconnected';
                case 'yandex_market':
                    if (!isYandexMarketLoaded) {
                        return 'loading';
                    }

                    return isIntegrationSourceConnected.yandex_market(yandexMarketData) ? 'connected' : 'disconnected';
            }
        },
        [isOzonLoaded, isWildberriesLoaded, isYandexMarketLoaded, ozonData, wildberriesData, yandexMarketData]
    );

    return { getConnectionState };
};
